import { OrderByNode } from '@jupiterone/query-language-parser';

// Values going into this look like either createdOn x.createdOn or null
const getIdentifierAndFieldName = (
  orderByField: string | null
): { sourceIdentifier: string; field: string | null } => {
  if (!orderByField) {
    return { sourceIdentifier: '', field: null };
  } else if (orderByField.split('.').length > 1) {
    const [sourceIdentifier, field] = orderByField.split('.');
    return { sourceIdentifier, field };
  } else {
    return { sourceIdentifier: '', field: orderByField };
  }
};

const buildOrderByNode = (
  query: string,
  orderByField: string | null,
  direction: 'asc' | 'desc'
): OrderByNode => {
  const { sourceIdentifier, field } = getIdentifierAndFieldName(orderByField);
  return {
    type: 'orderBy',
    selectors: [
      {
        type: 'orderBySelector',
        field,
        sourceIdentifier,
        direction,
      },
    ],
  };
};

export default buildOrderByNode;
